// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"0c50ec3a","66":"5e5c2912","67":"4e6cc2c8","269":"a5df6964","369":"893e85be","400":"5bb11a5a","409":"a6597a6e","444":"d8a98d9e","795":"1efa5753","868":"2a51b45c"}[chunkId] + ".chunk.js";
};